<ion-card-content class="ion-padding-horizontal-2 ion-padding-vertical-0">
	<ion-item lines='none'>
		<ion-button tabIndex="1" class="ion-margin-right-0" slot="end" color="secondary" fill="clear" (click)="clear()"
			[disabled]="disableClear">
			Clear
			<ion-icon slot="end" name="close-circle-outline" class="ion-font-xlg"></ion-icon>
		</ion-button>
	</ion-item>

	<ion-item lines="none">

		@if (props.inputmode === 'numeric') {
		<ion-input tabIndex="2" autoFocus="false" class="ion-font-sm" type="number" inputmode="numeric"
			[formControl]="$any(formControl)" [taFormlyAttributes]="field" placeholder="Input number here ..."
			pattern="^\d+$" (keypress)="integerValuesOnly($event)" (ionInput)="ionInput($event)">
		</ion-input>
		} @else {
		@if (props.inputmode === 'decimal') {
		<ion-input tabIndex="2" autoFocus="false" class="ion-font-sm" type="number" inputmode="decimal"
			[formControl]="$any(formControl)" [taFormlyAttributes]="field" placeholder="Input number here ..."
			pattern="^\d+(\.\d+)?$" (keypress)="decimalValuesOnly($event)" (ionInput)="ionInput($event)">
		</ion-input>
		} @else {
		<ion-input tabIndex="2" autoFocus="false" class="ion-font-sm" autocapitalize="true" autocomplete="true"
			autocorrect="true" spellcheck="true" type="text" [formControl]="$any(formControl)"
			[taFormlyAttributes]="field" [placeholder]="props.placeholder || 'Input answer here ...'"
			(ionInput)="ionInput($event)">
		</ion-input>
		}
		}

	</ion-item>
	<ion-item lines="none">
		@if (invalidNumber) {
		<ion-label class="ion-font-xs ion-margin-top-0" color="danger">
			Invalid whole number
		</ion-label>
		}
		@if (invalidDecimal) {
		<ion-label class="ion-font-xs ion-margin-top-0" color="danger">
			Invalid decimal number
		</ion-label>
		}
	</ion-item>
</ion-card-content>